export default __webpack_public_path__ + "624b76ebad0b55604eda5b14bdeb7afe.svg";